import Base from './Base';
import CompanyModel from './Company';

export default class CompanyUserModel extends Base  {
	public id: number;
	public full_name:string;
	public user_type:string;
	public user_id:number;
	public resetConnectionCode:boolean;
	private _firstname: string;
	private _insertion: string;
	private _lastname: string;
	private _phone1: string;
	private _phone2: string;
	private _email: string;
	private _state: number;
	private _company: object;
	
	constructor(data?: object) {
		super(null);

		this.id = 0;
		this.full_name = "";
		this.user_type = "";
		this.firstname = "";
		this.insertion = "";
		this.lastname = "";
		this.phone1 = "";
		this.phone2 = "";
		this.email = "";
		this.resetConnectionCode = false;
		//this.company = new CompanyModel(data);
		
		this.addData(data);
	}

	
	get firstname() {
		return this._firstname;
	}
	set firstname(val) {
		this._firstname = val;
	}

	get insertion() {
		return this._insertion;
	}
	set insertion(val) {
		this._insertion = val;
	}

	get lastname() {
		return this._lastname;
	}
	set lastname(val) {
		this._lastname = val;
	}

	get phone1() {
		return this._phone1;
	}
	set phone1(val) {
		this._phone1 = val;
	}

	get phone2() {
		return this._phone2;
	}
	set phone2(val) {
		this._phone2 = val;
	}

	get email() {
		return this._email;
	}
	set email(val) {
		this._email = val;
	}

	get state() {
		return this._state;
	}
	set state(val) {
		this._state = val;
	}
		
	get company() {
		return this._company;
	}
	set company(value) {
		this._company = value;
	}	
	
	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new CompanyUserModel();
	}


	
}